<div class="step__title">
    <span class="step__titleText step__titleText--pending">{{ title }}</span>
    <span class="step__titleText step__titleText--completed">{{ titleCompleted }}</span>
</div>

<ng-content></ng-content>

<span class="step__edit" i18n="configurator.general.edit">edit</span>
<mg-ui-checkmark></mg-ui-checkmark>
